import MockBatteryFeature from '../../impl/mock/feature/MockBatteryFeature';
import MockHeartRate from '../../impl/mock/feature/MockHeartRate';
import MockTemperature from '../../impl/mock/feature/MockTemperature';
import MockBloodPressure from '../../impl/mock/feature/MockBloodPressureFeature';
import MockSmartband from '../../impl/mock/manager/MockSmartband';

export {
  MockBatteryFeature as BatteryFeature,
  MockHeartRate as HeartRateFeature,
  MockTemperature as TemperatureFeature,
  MockBloodPressure as BloodPressureFeature,
  MockSmartband as Smartband,
};
